import { compactInteger, formatNumber, intComma } from 'humanize-plus'
import { Moment } from 'moment'

/* eslint-disable @typescript-eslint/explicit-member-accessibility */
export class TypeFormats {
  static COMPACT_INTEGER_FIXED = (value: number) => compactInteger(value, 1)
  static COMPACT_INTEGER_ROUND = (value: number) => compactInteger(value)
  static PERCENT = (value: number) => `${intComma(Math.round(value)) || 0}%`
  static PERCENT_WITH_DECIMAL = (value: number, numOfDecimals = 1) =>
    `${value ? intComma(value, numOfDecimals) : 0}%`
  static RAW_HUMANIZED = (value: number) => formatNumber(value)
}
/* eslint-enable @typescript-eslint/explicit-member-accessibility */

export const parseDateToRange = (startDate: Moment, endDate: Moment) => {
  if (startDate.isSame(endDate)) {
    return startDate.format('MMMM D, YYYY')
  }

  const startDateFormat = `MMMM D${
    startDate.isSame(endDate, 'year') ? '' : ', YYYY'
  }`
  const endDateFormat = startDate.isSame(endDate, 'month')
    ? 'D, YYYY'
    : 'MMMM D, YYYY'
  return `${startDate.format(startDateFormat)} – ${endDate.format(
    endDateFormat
  )}`
}
